.money {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
  white-space: nowrap;
}

/* Right-aligned in tables so columns line up; inline runs stay in the text flow. */
.aligned {
  text-align: right;
}

.in {
  color: var(--money-in);
}

.out {
  color: var(--money-out);
}

/* An actual overdraft or debt, not merely a debit. */
.negative {
  color: var(--money-negative);
}

.size-sm {
  font-size: var(--text-sm);
}
.size-base {
  font-size: var(--text-base);
}
.size-lg {
  font-size: var(--text-lg);
}
.size-xl {
  font-size: var(--text-xl);
}
.size-2xl {
  font-size: var(--text-2xl);
}
.size-3xl {
  font-size: var(--text-3xl);
}

.weight-normal {
  font-weight: var(--weight-normal);
}
.weight-medium {
  font-weight: var(--weight-medium);
}
.weight-semibold {
  font-weight: var(--weight-semibold);
}
